import {Component} from '@angular/core';

@Component({
  selector: 'app-error404',
  template: `<ng-container i18n="Page not found|Error message shown if web page is not found@@pagenotfound">
The page you requested is not available!
</ng-container>`
})
export class Error404Component {}
